import React, { useState } from "react";
import { useLocale } from "@davi-ai/retorik-framework";
import { defaultModeSetAction } from "../../redux/Actions";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import translation from "../../translations/menuItems.json"
import commonTranslation from '../../translations/common.json';
import Button from "../Common/Button";
import OnOffButton from './OnOffButtons';
import useDefaultMode from "../../redux/Hooks/Kiosk/useDefaultMode";

const DefaultModeChoice = () => {
  const locale: string = useLocale();
  const dispatch = useDispatchKiosk()
  const defaultMode = useDefaultMode()
  const [mode, setMode] = useState<number>(defaultMode || 1)

  const toggleDefaultMode = () => {
    setMode(mode === 1 ? 2 : 1)
  }

  const save = () => {
    dispatch(defaultModeSetAction(mode));
  }

  return (
    <div className="w-full h-9/10 flex flex-col justify-between">
      <div className="w-full flex flex-col gap-4 mt-6 px-1">
        <div className="flex flex-row justify-between items-center">
          {translation[locale]?.defaultmode.title || translation["fr-FR"].defaultmode.title}
          <OnOffButton
            toggle={mode === 1}
            returnFunction={toggleDefaultMode}
            values={{
              left: translation[locale]?.defaultmode.vocal || translation["fr-FR"].defaultmode.vocal,
              right: translation[locale]?.defaultmode.text || translation["fr-FR"].defaultmode.text
            }}
          />
        </div>
      </div>

      <div className="mb-2 mt-1 flex justify-center">
        <Button label={commonTranslation[locale]?.save || commonTranslation["fr-FR"].save} onClick={save}>
          {commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}
        </Button>
      </div>
    </div>
  );
};

export default DefaultModeChoice;
